__webpack_require__.p = "//static.hsappstatic.net/case-study-editor-ui/static-1.21495/";